(function() {
  'use strict';

  // ==================================================================
  // PHASE A: One-time setup (runs once on page load, never re-runs)
  // ==================================================================

  // ---- Auto-reopen cart drawer after login redirect (fallback) ----
  // This handles the case where a full page reload was unavoidable
  // (e.g., popup login session didn't propagate after retries).
  var checkoutIntent = false;

  // ---- Tax cert state (module-level so checkout handler can access it) ----
  var certState = { selectedFile: null, ocrValid: false, ocrResult: null, customerEmail: null };

  // Check URL param (fallback for classic accounts that respect return_url)
  var params = new URLSearchParams(window.location.search);
  if (params.has('open_cart')) {
    params.delete('open_cart');
    var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
    checkoutIntent = true;
  }

  // Check localStorage (works with new Customer Accounts)
  if (localStorage.getItem('qep_checkout_intent')) {
    localStorage.removeItem('qep_checkout_intent');
    checkoutIntent = true;
  }

  // Redirect to saved return URL after login (for fallback login links)
  var returnUrl = localStorage.getItem('qep_return_url');
  if (returnUrl) {
    localStorage.removeItem('qep_return_url');
    if (returnUrl !== window.location.href && returnUrl !== window.location.pathname) {
      if (checkoutIntent) localStorage.setItem('qep_checkout_intent', '1');
      window.location.href = returnUrl;
      return;
    }
  }

  // Auto-open cart drawer using the proper show() method
  if (checkoutIntent) {
    requestAnimationFrame(function() {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.show === 'function') {
        cartDrawer.show();
      }
    });
  }

  // ---- Set checkout intent before ANY login redirect ----
  document.addEventListener('click', function(e) {
    var link = e.target.closest('[data-checkout-intent]');
    if (link) {
      localStorage.setItem('qep_checkout_intent', '1');
      localStorage.setItem('qep_return_url', window.location.href);
    }
  });

  // ---- Save note (+ tax-exempt attributes) and redirect to checkout ----
  // Re-queries the DOM each time to handle innerHTML swaps
  function saveNoteThenCheckout() {
    var currentNote = document.querySelector('[id^="CartDrawerNote-"]');
    var note = currentNote ? currentNote.value : '';
    var payload = { note: note };

    // If a tax-exempt cert was just submitted, attach attributes for the order
    if (certState.fileUrl) {
      var certIdInput = document.getElementById('drawer-cert-id');
      var orgNameInput = document.getElementById('drawer-org-name');
      payload.attributes = {
        tax_exempt: 'true',
        tax_exempt_id: certIdInput ? certIdInput.value.trim() : '',
        tax_exempt_notes: orgNameInput ? orgNameInput.value.trim() : '',
        tax_exempt_file: certState.fileUrl
      };
    } else {
      // Already-exempt customer — read cert data from the badge's data attributes
      var badge = document.getElementById('tax-exempt-badge');
      if (badge && badge.dataset.exempt === 'true') {
        payload.attributes = {
          tax_exempt: 'true',
          tax_exempt_id: badge.dataset.certId || '',
          tax_exempt_notes: badge.dataset.certOrg || '',
          tax_exempt_file: badge.dataset.certUrl || ''
        };
        // If no file_url but we have a file_id, try to resolve it
        if (!badge.dataset.certUrl && badge.dataset.certFileId) {
          var apiUrl = document.body.dataset.apiUrl || 'https://qep-isbn-lookup.onrender.com';
          return fetch(apiUrl + '/api/tax-exempt/file-url?file_id=' + encodeURIComponent(badge.dataset.certFileId))
            .then(function(r) { return r.json(); })
            .then(function(data) {
              if (data.file_url) payload.attributes.tax_exempt_file = data.file_url;
            })
            .catch(function() { /* proceed without URL */ })
            .then(function() {
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
              });
            })
            .then(function() { window.location.href = '/checkout'; })
            .catch(function() { window.location.href = '/checkout'; });
        }
      }
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function() {
      window.location.href = '/checkout';
    }).catch(function() {
      window.location.href = '/checkout';
    });
  }

  // Intercept all .js-checkout-with-note buttons (Checkout, Skip)
  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('.js-checkout-with-note');
    if (btn) {
      e.preventDefault();
      btn.disabled = true;
      var btnText = btn.querySelector('.btn-text');

      // Check if tax cert form is visible (checkbox checked)
      var taxCertInline = document.querySelector('[id^="TaxCertInline-"]');
      if (taxCertInline && !taxCertInline.hidden) {
        var certIdInput = document.getElementById('drawer-cert-id');
        var orgNameInput = document.getElementById('drawer-org-name');
        var submitError = document.getElementById('drawer-submit-error');
        var certId = certIdInput ? certIdInput.value.trim() : '';
        var orgName = orgNameInput ? orgNameInput.value.trim() : '';

        // Check if manual warning notes are required
        var mwWrap = document.getElementById('drawer-manual-warn-wrap');
        var mwNotes = document.getElementById('drawer-manual-notes');
        var needsNotes = mwWrap && mwWrap.style.display !== 'none';
        var hasNotes = !needsNotes || (mwNotes && mwNotes.value.trim().length > 0);

        if (!certId || !orgName || !certState.selectedFile || !certState.ocrValid || !hasNotes) {
          var missing = [];
          if (!certState.selectedFile) missing.push('certificate file');
          if (!certId) missing.push('Certificate ID');
          if (!orgName) missing.push('Organization Name');
          if (!certState.ocrValid) missing.push('expiration acknowledgment');
          if (!hasNotes) missing.push('explanation notes');
          if (submitError) {
            submitError.textContent = 'Please provide your ' + missing.join(', ') + '.';
            submitError.style.display = 'block';
          }
          btn.disabled = false;
          return;
        }

        try {
          if (btnText) btnText.textContent = 'Submitting certificate...';
          var apiUrl = document.body.dataset.apiUrl || 'https://qep-isbn-lookup.onrender.com';
          var base64Full = await fileToBase64(certState.selectedFile);
          var base64Data = base64Full.split(',')[1];
          var expiryDate = null;
          if (certState.ocrResult) {
            var expirationInfo = findExpirationDate(certState.ocrResult);
            if (expirationInfo.found) expiryDate = expirationInfo.dateStr;
          }
          // Gather optional state/notes fields
          var noExpireCb = document.getElementById('drawer-no-expire-check');
          var manualNotesInput = document.getElementById('drawer-manual-notes');
          var payload = {
            customer_email: certState.customerEmail,
            cert_id: certId,
            org_name: orgName,
            file: { name: certState.selectedFile.name, type: certState.selectedFile.type, data: base64Data },
            ocr_valid: certState.ocrValid,
            expiry_date: expiryDate
          };
          if (noExpireCb && noExpireCb.checked) payload.no_expiry_acknowledged = true;
          if (manualNotesInput && manualNotesInput.value.trim()) payload.customer_notes = manualNotesInput.value.trim();

          var response = await fetch(apiUrl + '/api/tax-exempt/submit', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          var result = await response.json();
          if (!response.ok) throw new Error(result.error || 'Submission failed');
          // Store cert file URL for cart attributes
          certState.fileUrl = result.file_url || null;
        } catch (err) {
          console.error('Tax exempt submission error:', err);
          btn.disabled = false;
          if (btnText) btnText.textContent = 'Checkout';
          if (submitError) {
            submitError.textContent = err.message || 'Something went wrong. Please try again.';
            submitError.style.display = 'block';
          }
          return;
        }
      }

      if (btnText) btnText.textContent = 'Redirecting to checkout...';
      saveNoteThenCheckout();
    }
  });

  // ==================================================================
  // PHASE B: Element-specific bindings (runs on load + after section refresh)
  // ==================================================================

  function initDrawerElements() {
    // ---- Order Notes auto-save ----
    var noteTextarea = document.querySelector('[id^="CartDrawerNote-"]');
    if (noteTextarea && !noteTextarea.dataset.bound) {
      noteTextarea.dataset.bound = '1';
      var saveTimeout;
      noteTextarea.addEventListener('input', function() {
        clearTimeout(saveTimeout);
        saveTimeout = setTimeout(function() {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: noteTextarea.value })
          }).catch(function(err) { console.error('Failed to save cart note:', err); });
        }, 500);
      });
    }

    // ---- Tax Exempt Checkbox Toggle ----
    var taxExemptCheck = document.querySelector('[id^="tax-exempt-check-"]');
    var taxCertInline = document.querySelector('[id^="TaxCertInline-"]');

    if (taxExemptCheck && taxCertInline && !taxExemptCheck.dataset.bound) {
      taxExemptCheck.dataset.bound = '1';
      taxExemptCheck.addEventListener('change', function() {
        taxCertInline.hidden = !this.checked;
      });
    }

    // ---- Inline Login Form (Classic Customer Accounts) ----
    var loginSubmit = document.getElementById('drawer-login-submit');
    if (loginSubmit && !loginSubmit.dataset.bound) {
      loginSubmit.dataset.bound = '1';
      var loginEmail = document.getElementById('drawer-login-email');
      var loginPassword = document.getElementById('drawer-login-password');
      var loginError = document.getElementById('drawer-login-error');

      function showLoginError(msg) {
        if (loginError) { loginError.textContent = msg; loginError.style.display = 'block'; }
      }
      function hideLoginError() {
        if (loginError) { loginError.style.display = 'none'; loginError.textContent = ''; }
      }

      // Submit on Enter key from password field
      if (loginPassword) {
        loginPassword.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') loginSubmit.click();
        });
      }

      loginSubmit.addEventListener('click', async function() {
        if (!loginEmail || !loginPassword) return;
        var email = loginEmail.value.trim();
        var password = loginPassword.value;

        if (!email || !password) {
          showLoginError('Please enter your email and password.');
          return;
        }

        loginSubmit.disabled = true;
        hideLoginError();
        var btnText = loginSubmit.querySelector('.btn-text');
        var origText = btnText ? btnText.textContent : '';
        if (btnText) btnText.textContent = 'Signing in...';

        try {
          // Use hidden iframe for native form submission (handles Shopify's hCaptcha)
          var loginFormEl = document.getElementById('drawer-login-form-el');
          if (!loginFormEl) throw new Error('Login form not found');

          var iframeName = 'drawer-login-frame-' + Date.now();
          var iframe = document.createElement('iframe');
          iframe.name = iframeName;
          iframe.style.display = 'none';
          document.body.appendChild(iframe);

          // Point form submission at the hidden iframe
          loginFormEl.target = iframeName;

          // Listen for iframe load to detect success/failure
          var loginPromise = new Promise(function(resolve, reject) {
            var timeout = setTimeout(function() {
              reject(new Error('Login timed out. Please try again.'));
            }, 15000);

            iframe.onload = function() {
              clearTimeout(timeout);
              try {
                var iframeUrl = iframe.contentWindow.location.href;
                if (iframeUrl.includes('/account/login') || iframeUrl.includes('/challenge')) {
                  reject(new Error('Incorrect email or password. Please try again.'));
                } else {
                  resolve();
                }
              } catch (e) {
                // Cross-origin means redirect happened — likely success
                resolve();
              }
            };
          });

          // Submit form directly into the hidden iframe (same pattern as quote-list.js)
          loginFormEl.submit();

          await loginPromise;

          // Clean up iframe
          setTimeout(function() { iframe.remove(); }, 1000);

          // Login succeeded — full page reload to propagate auth state everywhere
          // Use open_cart param so the cart drawer reopens automatically after reload
          var reloadUrl = new URL(window.location.href);
          reloadUrl.searchParams.set('open_cart', 'checkout');
          window.location.href = reloadUrl.toString();
        } catch (err) {
          console.error('Login error:', err);
          showLoginError(err.message || 'Something went wrong. Please try again.');
          loginSubmit.disabled = false;
          if (btnText) btnText.textContent = origText;
          // Clean up any stale iframe
          var staleFrame = document.querySelector('iframe[name^="drawer-login-frame-"]');
          if (staleFrame) staleFrame.remove();
        }
      });
    }

    // ---- Tax Certificate Upload Logic (only if form exists) ----
    var form = document.getElementById('tax-cert-form');
    if (!form || form.dataset.bound) return;
    form.dataset.bound = '1';

    var dropzone = document.getElementById('drawer-dropzone');
    var fileInput = document.getElementById('drawer-cert-file');
    var filePreview = document.getElementById('drawer-file-preview');
    var fileName = document.getElementById('drawer-file-name');
    var fileRemove = document.getElementById('drawer-file-remove');
    var ocrStatus = document.getElementById('drawer-ocr-status');
    var submitError = document.getElementById('drawer-submit-error');

    // Reset module-level cert state
    certState.selectedFile = null;
    certState.ocrResult = null;
    certState.ocrValid = false;
    certState.customerEmail = form.closest('[data-customer-email]')?.dataset?.customerEmail;

    // ---- Drag & Drop ----
    if (dropzone && fileInput) {
      dropzone.addEventListener('click', function() { fileInput.click(); });

      dropzone.addEventListener('dragover', function(e) {
        e.preventDefault();
        dropzone.style.borderColor = 'rgb(var(--color-success-text, 76 175 80))';
        dropzone.style.background = 'rgb(var(--color-success-background, 232 245 233))';
      });

      dropzone.addEventListener('dragleave', function() {
        dropzone.style.borderColor = '';
        dropzone.style.background = '';
      });

      dropzone.addEventListener('drop', function(e) {
        e.preventDefault();
        dropzone.style.borderColor = '';
        dropzone.style.background = '';
        if (e.dataTransfer.files.length > 0) handleFile(e.dataTransfer.files[0]);
      });

      fileInput.addEventListener('change', function() {
        if (fileInput.files.length > 0) handleFile(fileInput.files[0]);
      });
    }

    // ---- File Remove ----
    if (fileRemove) {
      fileRemove.addEventListener('click', function() {
        certState.selectedFile = null;
        certState.ocrResult = null;
        certState.ocrValid = false;
        fileInput.value = '';
        filePreview.style.display = 'none';
        dropzone.style.display = '';
        resetOcrStatus();
        // Clear OCR-populated fields so re-upload can auto-fill fresh values
        var certIdField = document.getElementById('drawer-cert-id');
        var orgNameField = document.getElementById('drawer-org-name');
        if (certIdField) certIdField.value = '';
        if (orgNameField) orgNameField.value = '';
        // Hide state-specific UI on file remove
        var neWrap = document.getElementById('drawer-no-expire-wrap');
        var neCheck = document.getElementById('drawer-no-expire-check');
        var mwWrap = document.getElementById('drawer-manual-warn-wrap');
        var mwNotes = document.getElementById('drawer-manual-notes');
        if (neWrap) neWrap.style.display = 'none';
        if (neCheck) neCheck.checked = false;
        if (mwWrap) mwWrap.style.display = 'none';
        if (mwNotes) mwNotes.value = '';
      });
    }

    // ---- Non-expiring state checkbox listener ----
    var drawerNoExpireCheck = document.getElementById('drawer-no-expire-check');
    if (drawerNoExpireCheck) {
      drawerNoExpireCheck.addEventListener('change', function() {
        certState.ocrValid = drawerNoExpireCheck.checked;
      });
    }

    // ---- Manual warning notes listener ----
    var drawerManualNotes = document.getElementById('drawer-manual-notes');
    if (drawerManualNotes) {
      drawerManualNotes.addEventListener('input', function() {
        // Notes don't gate ocrValid but are needed for submission validation
      });
    }

    // ---- Handle File ----
    function handleFile(file) {
      var validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/tiff', 'application/pdf'];
      if (!validTypes.includes(file.type)) {
        showOcrStatus('error', 'Please upload an image (JPG, PNG, GIF, WEBP, TIFF) or PDF file.');
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        showOcrStatus('error', 'File is too large. Maximum size is 10MB.');
        return;
      }

      certState.selectedFile = file;
      fileName.textContent = file.name;
      filePreview.style.display = 'flex';
      dropzone.style.display = 'none';
      resetOcrStatus();
      runOcr(file);
    }

    // ---- OCR Processing ----
    async function runOcr(file) {
      showOcrStatus('processing', 'Scanning certificate for expiration date...');

      try {
        // For PDFs, render first page to image using PDF.js
        var ocrFile = file;
        if (file.type === 'application/pdf') {
          ocrFile = await renderPdfToImage(file);
          if (!ocrFile) {
            showOcrStatus('success', 'PDF uploaded. We will review your certificate manually. You can proceed.');
            certState.ocrValid = true;
            return;
          }
        }

        if (typeof Tesseract === 'undefined') {
          await new Promise(function(resolve, reject) {
            var script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/tesseract.js@5/dist/tesseract.min.js';
            script.onload = resolve;
            script.onerror = function() { reject(new Error('Failed to load OCR library')); };
            document.head.appendChild(script);
          });
        }

        // Pre-process: threshold to remove watermarks/light gray text, keep dark text
        var ocrInput = await preprocessForOcr(ocrFile);

        var result = await Tesseract.recognize(ocrInput, 'eng', {
          logger: function(m) {
            if (m.status === 'recognizing text' && m.progress) {
              showOcrStatus('processing', 'Scanning certificate... ' + Math.round(m.progress * 100) + '%');
            }
          }
        });

        var text = result.data.text || '';
        console.log('[QEP OCR] Raw text:', text);
        certState.ocrResult = text;

        // Auto-fill cert ID and org name from OCR text if fields are empty
        var certIdField = document.getElementById('drawer-cert-id');
        var orgNameField = document.getElementById('drawer-org-name');
        if (certIdField && !certIdField.value.trim()) {
          var extractedId = findCertificateId(text);
          if (extractedId) {
            certIdField.value = extractedId;
            console.log('[QEP OCR] Auto-filled cert ID:', extractedId);
          }
        }
        if (orgNameField && !orgNameField.value.trim()) {
          var extractedOrg = findOrganizationName(text);
          if (extractedOrg) {
            orgNameField.value = extractedOrg;
            console.log('[QEP OCR] Auto-filled org name:', extractedOrg);
          }
        }

        var expirationInfo = findExpirationDate(text);
        console.log('[QEP OCR] Expiration result:', expirationInfo);

        if (expirationInfo.found) {
          if (expirationInfo.expired) {
            showOcrStatus('error', 'This certificate appears to have expired on ' + expirationInfo.dateStr + '. Please upload a current certificate.');
            certState.ocrValid = false;
          } else {
            showOcrStatus('success', 'Certificate valid through ' + expirationInfo.dateStr + '. You may proceed.');
            certState.ocrValid = true;
          }
        } else {
          // No expiration found — check issuing state
          var stateInfo = findIssuingState(text);
          console.log('[QEP OCR] Issuing state:', stateInfo);

          // Hide previous state-specific UI
          var noExpireWrap = document.getElementById('drawer-no-expire-wrap');
          var noExpireCheck = document.getElementById('drawer-no-expire-check');
          var manualWarnWrap = document.getElementById('drawer-manual-warn-wrap');
          var manualNotes = document.getElementById('drawer-manual-notes');
          if (noExpireWrap) noExpireWrap.style.display = 'none';
          if (noExpireCheck) noExpireCheck.checked = false;
          if (manualWarnWrap) manualWarnWrap.style.display = 'none';
          if (manualNotes) manualNotes.value = '';

          if (stateInfo && NON_EXPIRING_STATES[stateInfo.abbr]) {
            // Non-expiring state — require acknowledgment checkbox
            showOcrStatus('info', 'This certificate appears to be issued by ' + stateInfo.name + ', which does not require an expiration date.');
            if (noExpireWrap) noExpireWrap.style.display = 'block';
            certState.ocrValid = false; // Will be set to true when checkbox is checked
          } else {
            // Unknown state or state that should have expiration — show warning + notes
            var warnMsg = 'We could not detect an expiration date on this certificate.';
            if (stateInfo) warnMsg += ' Certificate appears to be from ' + stateInfo.name + '.';
            showOcrStatus('warning', warnMsg);
            if (manualWarnWrap) manualWarnWrap.style.display = 'block';
            certState.ocrValid = true; // Allow submission but with warning
          }
        }
      } catch (err) {
        console.error('OCR error:', err);
        showOcrStatus('success', 'Certificate uploaded. Automatic scan unavailable. You can proceed and we will review manually.');
        certState.ocrValid = true;
      }
    }

    // ---- OCR Status Display ----
    function showOcrStatus(type, message) {
      if (!ocrStatus) return;
      ocrStatus.textContent = message;
      ocrStatus.style.display = 'block';
      if (type === 'processing') {
        ocrStatus.style.background = 'rgb(255 248 225)';
        ocrStatus.style.border = '1px solid rgb(255 193 7)';
        ocrStatus.style.color = '';
      } else if (type === 'success') {
        ocrStatus.style.background = 'rgb(232 245 233)';
        ocrStatus.style.border = '1px solid rgb(76 175 80)';
        ocrStatus.style.color = '';
      } else if (type === 'info') {
        ocrStatus.style.background = 'rgb(227 242 253)';
        ocrStatus.style.border = '1px solid rgb(66 165 245)';
        ocrStatus.style.color = 'rgb(21 101 192)';
      } else if (type === 'warning') {
        ocrStatus.style.background = 'rgb(255 243 224)';
        ocrStatus.style.border = '1px solid rgb(255 167 38)';
        ocrStatus.style.color = 'rgb(230 81 0)';
      } else if (type === 'error') {
        ocrStatus.style.background = 'rgb(252 228 236)';
        ocrStatus.style.border = '1px solid rgb(229 115 115)';
        ocrStatus.style.color = 'rgb(198 40 40)';
      }
    }

    function resetOcrStatus() {
      if (!ocrStatus) return;
      ocrStatus.style.display = 'none';
      ocrStatus.textContent = '';
    }

  }

  // ---- Shared utility: Render PDF first page to image via PDF.js ----
  async function renderPdfToImage(file) {
    try {
      if (typeof pdfjsLib === 'undefined') {
        await new Promise(function(resolve, reject) {
          var script = document.createElement('script');
          script.src = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.9.155/build/pdf.min.mjs';
          script.type = 'module';
          script.onload = resolve;
          script.onerror = function() { reject(new Error('Failed to load PDF.js')); };
          document.head.appendChild(script);
        });
      }
      // PDF.js loaded as ES module won't set pdfjsLib globally — use import()
      var pdfjs = window.pdfjsLib;
      if (!pdfjs) {
        var mod = await import('https://cdn.jsdelivr.net/npm/pdfjs-dist@4.9.155/build/pdf.min.mjs');
        pdfjs = mod;
      }
      pdfjs.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.9.155/build/pdf.worker.min.mjs';
      var arrayBuffer = await file.arrayBuffer();
      var pdf = await pdfjs.getDocument({ data: arrayBuffer }).promise;
      var page = await pdf.getPage(1);
      var scale = 2; // 2x for better OCR resolution
      var viewport = page.getViewport({ scale: scale });
      var canvas = document.createElement('canvas');
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      var ctx = canvas.getContext('2d');
      await page.render({ canvasContext: ctx, viewport: viewport }).promise;
      return await new Promise(function(resolve) {
        canvas.toBlob(function(blob) { resolve(blob); }, 'image/png');
      });
    } catch (err) {
      console.error('[QEP OCR] PDF rendering failed:', err);
      return null;
    }
  }

  // ---- Shared utility: Pre-process image for OCR (removes watermarks + colored borders) ----
  function preprocessForOcr(file) {
    return new Promise(function(resolve) {
      var img = new Image();
      img.onload = function() {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var data = imageData.data;
        // Keep only dark, low-saturation pixels (black/dark gray text).
        // Removes: colored borders (high saturation), watermarks (light), backgrounds.
        for (var i = 0; i < data.length; i += 4) {
          var r = data[i], g = data[i + 1], b = data[i + 2];
          var gray = r * 0.299 + g * 0.587 + b * 0.114;
          var mx = Math.max(r, g, b);
          var mn = Math.min(r, g, b);
          var sat = mx > 0 ? (mx - mn) / mx : 0;
          var isText = gray < 120 && sat < 0.35;
          data[i] = data[i + 1] = data[i + 2] = isText ? 0 : 255;
        }
        ctx.putImageData(imageData, 0, 0);
        canvas.toBlob(function(blob) {
          resolve(blob || file);
        }, 'image/png');
        URL.revokeObjectURL(img.src);
      };
      img.onerror = function() { resolve(file); };
      img.src = URL.createObjectURL(file);
    });
  }

  // ---- Shared utility: Extract Certificate / Exemption ID from OCR text ----
  function findCertificateId(text) {
    var patterns = [
      // Labeled patterns (most specific first)
      /(?:certificate\s*(?:no|number|#|id)[.:\s]*)\s*([A-Z0-9][\w\-]{2,})/i,
      /(?:exemption\s*(?:no|number|#|id)[.:\s]*)\s*([A-Z0-9][\w\-]{2,})/i,
      /(?:permit\s*(?:no|number|#|id)[.:\s]*)\s*([A-Z0-9][\w\-]{2,})/i,
      /(?:EIN|FEIN|Tax\s*ID|TIN)[.:\s]*\s*([\d][\d\-]{4,})/i,
      // "Sales Tax Exemption E99386127" or "Tax Exemption E99386127" (ID follows directly)
      /(?:sales\s+)?tax\s+exemption\s+([A-Z]\d{4,})/i,
      /exemption\s+([A-Z]\d{4,})/i,
      // Standalone alphanumeric ID: letter + 6+ digits (e.g. E99386127)
      /\b([A-Z]\d{6,})\b/
    ];
    for (var i = 0; i < patterns.length; i++) {
      var m = text.match(patterns[i]);
      if (m) return m[1].trim();
    }
    return null;
  }

  // ---- Shared utility: Extract Organization Name from OCR text ----
  function findOrganizationName(text) {
    // Words that describe org categories, not actual org names
    var categoryWords = /^(charitable|non.?profit|religious|educational|government|exempt|type|status|purpose|category)$/i;

    // Phase 1: Labeled patterns (most reliable)
    var labeledPatterns = [
      // "Organization Name: ..." or "Org Name: ..." (most specific)
      /(?:organization\s*name|org\s*name|entity\s*name|business\s*name|taxpayer\s*name|name\s*of\s*(?:organization|entity))[.:\s]*\s*([A-Z][A-Za-z0-9 &.,'\-]{2,})/i,
      // "Organization: ..." or "Org: ..." (require colon/dot, not just whitespace)
      /(?:org(?:anization)?)\s*[.:]\s*([A-Z][A-Za-z0-9 &.,'\-]{2,})/i,
      // Handle common OCR typo "oragnisation"
      /(?:ora?gni[sz]ation\s*(?:name)?)\s*[.:\s]\s*([A-Z][A-Za-z0-9 &.,'\-]{2,})/i
    ];
    for (var i = 0; i < labeledPatterns.length; i++) {
      var m = text.match(labeledPatterns[i]);
      if (m) {
        var name = m[1].trim().replace(/\s+(Address|Street|Suite|City|State|Zip|Phone|Fax|Email|Charitable|Non.?profit|Religious|Educational|Government).*$/i, '').trim();
        // Reject if the captured value is just a category word, not an actual name
        if (name.length > 2 && !categoryWords.test(name)) return name;
      }
    }

    // Phase 2: Find lines containing entity-type suffixes (Foundation, Inc, LLC, etc.)
    var lines = text.split(/\n/);
    var entityPattern = /\b(Foundation|Inc\.?|LLC|Corp(?:oration)?\.?|Association|Co(?:mpany)?\.?|Ltd\.?|L\.?P\.?|Trust|Ministry|Ministries|Church|University|College|School|Institute|Society|Council)\b/i;
    for (var j = 0; j < lines.length; j++) {
      var line = lines[j].trim();
      if (line.length > 4 && line.length < 80 && entityPattern.test(line)) {
        // Clean up: remove leading numbers, bullet chars, trailing address-like content
        var cleaned = line.replace(/^[\d\.\-\)\s]+/, '').replace(/\s+\d+.*$/, '').replace(/\s+(Address|Street|Suite|City|State|Zip).*$/i, '').trim();
        if (cleaned.length > 4 && /^[A-Z]/.test(cleaned)) return cleaned;
      }
    }
    return null;
  }

  // ---- States where tax exemption certificates do not expire ----
  var NON_EXPIRING_STATES = {
    'TX': 'Texas', 'CA': 'California', 'NY': 'New York',
    'GA': 'Georgia', 'OH': 'Ohio', 'PA': 'Pennsylvania', 'NJ': 'New Jersey'
  };

  // ---- Shared utility: Extract Issuing State from OCR text ----
  function findIssuingState(text) {
    var stateMap = {
      'Alabama':'AL','Alaska':'AK','Arizona':'AZ','Arkansas':'AR','California':'CA',
      'Colorado':'CO','Connecticut':'CT','Delaware':'DE','Florida':'FL','Georgia':'GA',
      'Hawaii':'HI','Idaho':'ID','Illinois':'IL','Indiana':'IN','Iowa':'IA',
      'Kansas':'KS','Kentucky':'KY','Louisiana':'LA','Maine':'ME','Maryland':'MD',
      'Massachusetts':'MA','Michigan':'MI','Minnesota':'MN','Mississippi':'MS','Missouri':'MO',
      'Montana':'MT','Nebraska':'NE','Nevada':'NV','New Hampshire':'NH','New Jersey':'NJ',
      'New Mexico':'NM','New York':'NY','North Carolina':'NC','North Dakota':'ND','Ohio':'OH',
      'Oklahoma':'OK','Oregon':'OR','Pennsylvania':'PA','Rhode Island':'RI','South Carolina':'SC',
      'South Dakota':'SD','Tennessee':'TN','Texas':'TX','Utah':'UT','Vermont':'VT',
      'Virginia':'VA','Washington':'WA','West Virginia':'WV','Wisconsin':'WI','Wyoming':'WY',
      'District of Columbia':'DC'
    };
    var stateOfPattern = /(?:state|commonwealth)\s+of\s+([A-Z][a-z]+(?:\s+[A-Z][a-z]+)*)/i;
    var m = text.match(stateOfPattern);
    if (m) {
      var name = m[1].trim();
      var normalized = name.replace(/\w\S*/g, function(t) { return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase(); });
      if (stateMap[normalized]) return { name: normalized, abbr: stateMap[normalized] };
    }
    var stateNames = Object.keys(stateMap).sort(function(a, b) { return b.length - a.length; });
    for (var i = 0; i < stateNames.length; i++) {
      var re = new RegExp('\\b' + stateNames[i].replace(/\s+/g, '\\s+') + '\\b', 'i');
      if (re.test(text)) return { name: stateNames[i], abbr: stateMap[stateNames[i]] };
    }
    var abbrMap = {};
    for (var sn in stateMap) abbrMap[stateMap[sn]] = sn;
    var abbrPattern = /[,\s]([A-Z]{2})[\s,\d]/g;
    var am;
    while ((am = abbrPattern.exec(text)) !== null) {
      if (abbrMap[am[1]]) return { name: abbrMap[am[1]], abbr: am[1] };
    }
    return null;
  }

  // ---- Shared utility: Find Expiration Date ----
  function findExpirationDate(text) {
    // Normalize: collapse whitespace, replace OCR dash/dot variants, remove spaces around date separators
    var normalized = text.replace(/\n/g, ' ').replace(/\s+/g, ' ')
      .replace(/[\u2010\u2011\u2012\u2013\u2014\u2015\u2212\uFE58\uFE63\uFF0D]/g, '-')
      .replace(/(\d)\s*[.\-\/]\s*(\d)/g, '$1-$2');
    var patterns = [
      /(?:expir(?:es|ation|y)?[:\s]*(?:date)?[:\s]*)([\d]{1,2}[\/-][\d]{1,2}[\/-][\d]{2,4})/i,
      /(?:expir(?:es|ation|y)?[:\s]*(?:date)?[:\s]*)([\d]{4}[\/-][\d]{1,2}[\/-][\d]{1,2})/i,
      /(?:valid\s+(?:through|until|thru)[:\s]*)([\d]{1,2}[\/-][\d]{1,2}[\/-][\d]{2,4})/i,
      /(?:valid\s+(?:through|until|thru)[:\s]*)([\d]{4}[\/-][\d]{1,2}[\/-][\d]{1,2})/i,
      /(?:effective\s+through[:\s]*)([\d]{1,2}[\/-][\d]{1,2}[\/-][\d]{2,4})/i,
      /(?:expir(?:es|ation|y)?[:\s]*(?:date)?[:\s]*)([A-Za-z]+\.?\s+\d{1,2},?\s+\d{4})/i,
      /(?:valid\s+(?:through|until|thru)[:\s]*)([A-Za-z]+\.?\s+\d{1,2},?\s+\d{4})/i,
      /expir[a-z]*[^\d]{0,20}(\d{1,2}[\/-]\d{1,2}[\/-]\d{2,4})/i,
      /expir[a-z]*[^\d]{0,20}(\d{4}[\/-]\d{1,2}[\/-]\d{1,2})/i
    ];

    for (var i = 0; i < patterns.length; i++) {
      var match = normalized.match(patterns[i]);
      if (match && match[1]) {
        var dateStr = match[1].trim();
        var parsedDate = parseFlexibleDate(dateStr);
        if (parsedDate) {
          var now = new Date();
          now.setHours(0, 0, 0, 0);
          return {
            found: true,
            expired: parsedDate < now,
            dateStr: parsedDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
          };
        }
      }
    }

    // If the cert explicitly says it doesn't expire, skip fallback entirely
    if (/does\s*not\s*expire|no\s*expir|non[\s-]*expir|until\s*revoked|do\s*not\s*carry\s*an?\s*expir|remain[s]?\s*(?:in\s*)?(?:effect|valid)\s*(?:until\s*revoked|indefinitely)/i.test(normalized)) {
      console.log('[QEP OCR] Cert contains no-expiration language, treating as non-expiring');
      return { found: false };
    }

    // Fallback: find ALL dates in text, return the latest future date (likely expiration)
    // First, strip dates explicitly labeled as issue/start/signature dates so they don't get picked up
    var fallbackText = normalized
      .replace(/(?:issue\s*date|date\s*of\s*issue|issued?|effective\s*date(?!\s*through)|(?:authorized\s*)?signature\s*date|signed?\s*date|date\s*signed)[:\s]*[\d]{1,4}[\/-][\d]{1,2}[\/-][\d]{1,4}/gi, '')
      .replace(/(?:issue\s*date|date\s*of\s*issue|issued?|effective\s*date(?!\s*through)|(?:authorized\s*)?signature\s*date|signed?\s*date|date\s*signed)[:\s]*[A-Za-z]+\.?\s+\d{1,2},?\s+\d{4}/gi, '');
    console.log('[QEP OCR] Keyword patterns failed, trying fallback date scan');
    var allDates = [];
    var fallbackPatterns = [
      /(\d{4}[\/-]\d{1,2}[\/-]\d{1,2})/g,
      /(\d{1,2}[\/-]\d{1,2}[\/-]\d{2,4})/g
    ];
    for (var j = 0; j < fallbackPatterns.length; j++) {
      var m;
      while ((m = fallbackPatterns[j].exec(fallbackText)) !== null) {
        var pd = parseFlexibleDate(m[1]);
        if (pd) allDates.push(pd);
      }
    }
    if (allDates.length > 0) {
      allDates.sort(function(a, b) { return b - a; }); // latest first
      var latest = allDates[0];
      var now = new Date();
      now.setHours(0, 0, 0, 0);
      console.log('[QEP OCR] Fallback found', allDates.length, 'dates, latest:', latest);
      return {
        found: true,
        expired: latest < now,
        dateStr: latest.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
      };
    }

    return { found: false };
  }

  // ---- Shared utility: Parse Flexible Date ----
  function parseFlexibleDate(str) {
    // Try YYYY-MM-DD first (local time, avoids UTC shift from Date constructor)
    var parts = str.match(/(\d{4})[\/-](\d{1,2})[\/-](\d{1,2})/);
    if (parts) {
      var d = new Date(parseInt(parts[1]), parseInt(parts[2]) - 1, parseInt(parts[3]));
      if (!isNaN(d.getTime()) && d.getFullYear() > 2000) return d;
    }

    // Try MM/DD/YYYY or MM-DD-YYYY
    parts = str.match(/(\d{1,2})[\/-](\d{1,2})[\/-](\d{2,4})/);
    if (parts) {
      var year = parseInt(parts[3]);
      if (year < 100) year += 2000;
      var d = new Date(year, parseInt(parts[1]) - 1, parseInt(parts[2]));
      if (!isNaN(d.getTime()) && d.getFullYear() > 2000) return d;
    }

    // Fallback for named months (e.g., "December 31, 2099")
    var d = new Date(str);
    if (!isNaN(d.getTime()) && d.getFullYear() > 2000) return d;
    return null;
  }

  // ---- Shared utility: File to Base64 ----
  function fileToBase64(file) {
    return new Promise(function(resolve, reject) {
      var reader = new FileReader();
      reader.onload = function() { resolve(reader.result); };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  // ---- Initialize on page load ----
  initDrawerElements();

  // ---- Re-initialize after section refresh (e.g., after login) ----
  document.addEventListener('cart:refreshed', initDrawerElements);

})();
